import React from 'react';
import { ROUTE_CATEGORIES } from '../constants';
import { RedirectWithQueryParams } from './LegacyRoutes';

export const LEGACY_CATEGORY_ROUTE = [
  <RedirectWithQueryParams
    key="LegacyCategoryRoute"
    from={`/shop/:category(${ROUTE_CATEGORIES})/:subcategory?`}
    to={`/women/products/:category(${ROUTE_CATEGORIES})/:subcategory?`}
    exact
  />,
  <RedirectWithQueryParams
    key="LegacyCategoryRouteOnlyShop"
    from="/shop"
    to="/women/products/clothing"
    exact
  />,
  <RedirectWithQueryParams
    key="LegacyCategoryRouteOnlyShop"
    from="/shop/new"
    to="/women/products/new"
    exact
  />
];
